module.exports = __webpack_public_path__ + "static/img/C (20).48ae6077.png";